import React, { useCallback, useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import Logo from "../../admin/assets/logo.png";
import profileSvg from "../../admin/assets/sidebar/profile.svg";
import "../../Mycomponent/css/header.css";
import SemButton from "../../common/components/Button";
import { ZustandStore } from "../../store/zustand-store";
import { Logout } from "../../Mycomponent/share/upDater/constant";
import { Flex } from "@semcore/ui/flex-box";
import { sites } from "../../Navigation/constant";
import { Typography, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import LanguageSelect from "./LanguageChange";
import Services from "./Services";
import ServicesTooltip from "../../Mycomponent/share/components/ToolTip/ServicesTooltip";
import AddProjectStore from "../../store/AddProjectStore";
import { Helmet } from "react-helmet";
import Skeleton from "@mui/material/Skeleton";
import { getContrastTextColor } from "../../Mycomponent/share/components/white-label/helper";

const ADMIN_EMAILS = [
  "alekh@rankspro.io",
  "singhashish1.sh@gmail.com",
  "ravi@rankspro.io",
];

const UserHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const { white_lable, appliedWhiteLable, whitelable_loaded } = AddProjectStore(
    (state) => state
  );

  const isMobile = useMediaQuery("(max-width:768px)");
  const EMAIL = useSelector((state) => state?.email);
  const user_type = localStorage.getItem("user_type");
  const isAdmin = localStorage.getItem("isAdmin") === "true";

  const { isSidebarOpen, setSidebarOpen, customer_plan } = ZustandStore(
    (state) => state
  );
  const isUpgradePage = useMemo(() => pathname === "/upgrade", [pathname]);
  const userIsSubscribe = useMemo(
    () => customer_plan?.user_type === "subscription",
    [customer_plan]
  );

  const handleAdminRoute = useCallback(() => {
    dispatch({ type: "SHOWMENU", payload: false });
    navigate("/admin");
  }, [dispatch, navigate]);

  const Profile = useCallback(() => navigate("account"), [navigate]);

  const style = {
    bgColor: white_lable.theme_color || "#f7f7f7",
    color: getContrastTextColor(white_lable.theme_color),
  };
  return (
    <>
      {whitelable_loaded ? (
        <>
          {appliedWhiteLable.favicon ? (
            <Helmet>
              <link
                rel="icon"
                type="image/png"
                href={appliedWhiteLable.favicon}
                sizes="16x16"
              />
            </Helmet>
          ) : (
            <Helmet>
              <link
                rel="apple-touch-icon"
                sizes="180x180"
                href="https://cdn.mcauto-images-production.sendgrid.net/3d468aec49e21e68/c3aa0b21-eec7-4950-ac09-bf9ec3589516/180x180.png"
              />
              <link
                rel="icon"
                type="image/png"
                sizes="32x32"
                href="https://cdn.mcauto-images-production.sendgrid.net/3d468aec49e21e68/26bdf7c8-ba10-4106-80dc-79aaaad5a78d/32x32.png"
              />
              <link
                rel="icon"
                type="image/png"
                sizes="16x16"
                href="https://cdn.mcauto-images-production.sendgrid.net/3d468aec49e21e68/2d9002df-ef98-42ac-bd4f-1476e4cc06db/16x16.png"
              />
            </Helmet>
          )}
          <div
            className="navBar py-1 px-3 d-flex align-items-center"
            style={{
              backgroundColor: style.bgColor,
            }}
          >
            <div style={{ width: isMobile ? "auto" : "230px" }}>
              <Link to={"/dashboard"}>
                <img
                  src={appliedWhiteLable?.header_logo || Logo}
                  alt="RanksPro.io"
                  key={appliedWhiteLable?.header_logo || Logo}
                  style={{
                    width: "170px",
                    objectFit: "contain",
                    maxHeight: "40px",
                  }}
                />
              </Link>
            </div>

            {isMobile ? null : appliedWhiteLable.show_header_custom_links ? (
              appliedWhiteLable.header_custom_links?.length > 0 &&
              appliedWhiteLable.header_custom_links?.map((link) => {
                return (
                  <Flex
                    gap={6}
                    alignItems={"flex-center"}
                    ml={2}
                    mr={2}
                    key={link.label}
                  >
                    <Link
                      to={link.url}
                      target="_blank"
                      className="d-flex align-items-center"
                    >
                      <Typography
                        className="heading-small"
                        sx={{
                          color: style.color,
                          fontWeight: 500,
                          fontFamily: "Work Sans",
                          ":hover": {
                            textDecoration: "underline",
                          },
                        }}
                      >
                        {link.label}
                      </Typography>
                    </Link>
                  </Flex>
                );
              })
            ) : (
              <>
                {!isMobile && appliedWhiteLable.show_header_links && (
                  <Flex gap={6} alignItems={"flex-center"} ml={2} mr={2}>
                    <Link
                      to={sites}
                      target="_blank"
                      className="d-flex align-items-center"
                    >
                      <Typography
                        className="heading-small"
                        sx={{
                          color: style.color,
                          fontWeight: 500,
                          fontFamily: "Work Sans",
                          ":hover": {
                            textDecoration: "underline",
                          },
                        }}
                      >
                        {t("header.user.buy_guest_post.title")}
                      </Typography>
                    </Link>
                  </Flex>
                )}
                {!isMobile && appliedWhiteLable.show_header_links && (
                  <ServicesTooltip
                    title={t("header.user.services.title")}
                    color={style.color}
                  >
                    <Services />
                  </ServicesTooltip>
                )}
              </>
            )}

            <ul className="nv-ul ms-auto">
              {appliedWhiteLable?.show_translation && (
                <li>
                  <LanguageSelect />
                </li>
              )}
              <li className="flex-none-sm">
                <Link to={"https://help.rankspro.io/"} target="_blank">
                  <SemButton
                    name={t("header.user.help.title")}
                    color="#334155"
                    size="m"
                    hMin="30px"
                  />
                </Link>
              </li>
              {user_type !== "organization" &&
                !userIsSubscribe &&
                appliedWhiteLable?.show_upgrade && (
                  <li className="flex-none-sm">
                    <Link to="upgrade" className="header-upgrade">
                      <SemButton
                        name={t("header.user.upgrade.title")}
                        color="#334155"
                        size="m"
                        hMin="30px"
                      />
                    </Link>
                  </li>
                )}
              <li>
                <div className="nv-select">
                  <div className="nv-select_con">
                    <ul>
                      <li
                        onClick={Profile}
                        className="heading-small font-regular"
                      >
                        {t("header.user.account.title")}
                      </li>
                      {isAdmin && ADMIN_EMAILS.includes(EMAIL) && (
                        <>
                          <li
                            className="heading-small font-regular"
                            onClick={handleAdminRoute}
                          >
                            {t("header.user.admin.title")}
                          </li>
                        </>
                      )}
                      <li
                        className="heading-small font-regular"
                        onClick={() => navigate("/account/whitelabel")}
                      >
                        White Label
                      </li>
                      <a
                        href="https://rankspro-io.getrewardful.com/signup"
                        target="_blank"
                      >
                        <li className="heading-small font-regular">
                          Affiliate
                        </li>
                      </a>
                      {user_type !== "organization" && (
                        <li
                          className={`${
                            userIsSubscribe
                              ? "heading-small font-regular"
                              : "flex-md heading-small font-regular"
                          }`}
                        >
                          <Link to="upgrade">
                            {t("header.user.upgrade.title")}
                          </Link>
                        </li>
                      )}
                      <li
                        onClick={() => Logout(EMAIL)}
                        className="heading-small font-regular"
                      >
                        {t("header.user.logout.title")}
                      </li>
                    </ul>
                  </div>
                  <img src={profileSvg} alt="profileSvg" className="us-logo" />
                </div>
              </li>
              {!isUpgradePage && (
                <li className="top-bar_menu">
                  {isSidebarOpen ? (
                    <CloseIcon
                      fontSize="large"
                      onClick={() => setSidebarOpen(false)}
                    />
                  ) : (
                    <MenuIcon
                      fontSize="large"
                      onClick={() => setSidebarOpen(true)}
                    />
                  )}
                </li>
              )}
            </ul>
          </div>
        </>
      ) : (
        <Skeleton
          height={50}
          animation="wave"
          className="navBar"
          variant="rectangular"
        />
      )}
    </>
  );
};

export default React.memo(UserHeader);
